import React from 'react';

export default function Popover({ children }) {
  return (
    <div
      data-component-name='Popover'
      className='rounded-md bg-white-400 border-blue-50 border shadow-md px-[11px] py-2 text-blue-500 text-base'
    >
      {children}
    </div>
  );
}
